<template>
<div class="chapter">
<div class="inner_page">
<h2 class="PT">GAIA</h2>
<p class="PIT">Sometimes I wonder what I would say if I were ever asked out on a date.</p>
<p class="PTX">You’d think that since it’s never happened to me, I might have had some time in the past seventeen years to formulate the perfect response. You’d think that with all the movies I’ve seen, I would have at least picked up some cheesy line. Some doe-eyed, swooning acceptance.</p>
<p class="PTX">But I pretty much stay away from romantic comedies. There’s no relationship advice to be had from a Neil LaBute film.</p>
<p class="PTX">Besides, you can’t formulate the perfect response for a situation you can’t remotely imagine.</p>
<p class="PTX">I figure that if it ever does happen (not probable), I’ll end up saying something along the lines of “uh” or slight variations thereof.</p>
<p class="PTX">“Uh . . . uh,” if the guy’s a freak.</p>
<p class="PTX">“Uh . . . huh,” if the guy’s a nonfreak.</p>
<p class="PTX">I wonder what Heather said to Sam when he first asked her out. Probably something disgustingly perfect. Something right out of a movie. Something like, “I was wondering when you’d ask.” Or maybe Heather asked Sam out. And he said something like, “It would be my honor.”</p>
<p class="PTX">Okay. Stomach now reacting badly. Must think about something else.</p>
<p class="PTX">What did Heather say when <span class="txit">Ed</span> asked her out?</p>
<p class="PTX">Okay. Stomach now severely cramping.</p>
<p class="PTX">So what happens after the “Uh . . . huh”?</p>
<p class="PTX">Awkward pauses, I assume. Idiot small talk, sweaty palms (his), dry mouth (also his), bad food. (I imagine dates don’t happen at places where they have good food—like Gray’s Papaya or Dojo’s.)</p>
<p class="PTX">And I won’t even get into what happens after the most likely difficult digestion. What does the nonfreak expect at that point? Hand holding? Kissing? Groping? Heavy groping? Sex?</p>
<p class="PTX">Stomach no longer wishes to be a component of body.</p>
<p class="PTX">Must stop here.</p>
<p class="PTX">Luckily I won’t ever have to deal with any of this. Because no nonfreak will ever ask me out. And no freak will ever get more than the initial grunt.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part2.vue?1a3a42ec